export const enviroment = {
  baseURL: 'https://test-api.swiftmedix.com/api-gateway',
  GOOGLE_OAUTH_CLIENT_ID:
    '1087093173076-5h2qivq3shsduafgvk4bapedshsbb73u.apps.googleusercontent.com',
  INDIVIDUAL_APP: 'https://test.care.swiftmedix.com/',
  BUCKET_URL: 'https://test.bucket.swiftmedix.com',
};
